import { resolvePhoneDTO } from './phone';
import { t } from '@i18n';

const H = {
  getUrlParam(key) {
    return new URLSearchParams(window.location.search).get(key) || null;
  },


  getShareId() {
    const params = new URL(document.location.href).searchParams;
    return params.get("scid");
  },

  Parser: {
    phone: (value, cleanMode = false) => {
      if (!value) return value;

      // Remove todos os caracteres não numéricos
      const cleanValue = value.replace(/[^\d]/g, "");
      
      let phoneNumber;
      
      // Verifica se tem o prefixo +55 (formato internacional)
      if (cleanValue.startsWith('55') && cleanValue.length >= 12) {
        // Remove o código do país (55) e pega os dígitos brasileiros
        phoneNumber = cleanValue.slice(2);
      } else if (cleanValue.length >= 10 && cleanValue.length <= 11) {
        // Formato nacional (sem +55)
        phoneNumber = cleanValue;
      } else {
        // Formato inválido, retorna como está
        return value;
      }

      // Se cleanMode está ativo, retorna apenas o formato limpo +55XXXXXXXXXX
      if (cleanMode) {
        if (phoneNumber.length === 10 || phoneNumber.length === 11) {
          return `+55${phoneNumber}`;
        }
        // Para números parciais no cleanMode, retorna o que temos
        return phoneNumber.length >= 2 ? `+55${phoneNumber}` : value;
      }

      // Formata conforme a máscara desejada para números brasileiros
      if (phoneNumber.length === 11) {
        // Formato: +55 (XX) 9 XXXX-XXXX
        const match = phoneNumber.match(/^(\d{2})(\d{1})(\d{4})(\d{4})$/);
        if (match) {
          return `+55 (${match[1]}) ${match[2]} ${match[3]}-${match[4]}`;
        }
      } else if (phoneNumber.length === 10) {
        // Formato: +55 (XX) 9XXX-XXXX (formato antigo)
        const match = phoneNumber.match(/^(\d{2})(\d{4})(\d{4})$/);
        if (match) {
          return `+55 (${match[1]}) ${match[2]}-${match[3]}`;
        }
      }

      // Para números parciais, formata progressivamente
      if (phoneNumber.length <= 2) {
        return `+55 (${phoneNumber}`;
      } else if (phoneNumber.length <= 3) {
        return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(2)}`;
      } else if (phoneNumber.length <= 7) {
        return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(2, 3)} ${phoneNumber.slice(3)}`;
      } else if (phoneNumber.length <= 10) {
        return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(2, 3)} ${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7)}`;
      } else {
        return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(2, 3)} ${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7, 11)}`;
      }
    },

    cpf: (value) => {
      return value.replace(/\D/g, '');
    },

    email: (value) => {
      return value.trim().toLowerCase();
    },

    fullName: (value) => {
      return value.trim();
    },

    date: {
      ddmmyyyy: (value) => {
        return value.split("-").reverse().join("/");
      },
    },

    price: {
      brl: (cents) => {
        if (!cents) return cents;
        const numericValue = `${cents}`?.replace(/\D/g, "");
        const integerPart =
          numericValue.slice(0, -2)?.replace(/^0+/, "") || "0";
        const decimalPart = numericValue.slice(-2);

        const formattedInteger = integerPart.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          "."
        );

        return `${formattedInteger},${decimalPart}`;
      },
    },

    interval: {
      adjective: (interval) => {
        return {
          week: t('interval.week.adjective'),
          month: t('interval.month.adjective'),
          bimonthly: t('interval.bimonthly.adjective'),
          quarterly: t('interval.quarterly.adjective'),
          semiannual: t('interval.semiannual.adjective'),
          year: t('interval.year.adjective'),
          lifetime: t('interval.lifetime.adjective'),
        }[interval];
      },
      noun: (interval) => {
        return {
          week: t('interval.week.noun'),
          month: t('interval.month.noun'),
          bimonthly: t('interval.bimonthly.noun'),
          quarterly: t('interval.quarterly.noun'),
          semiannual: t('interval.semiannual.noun'),
          year: t('interval.year.noun'),
          lifetime: t('interval.lifetime.noun'),
        }[interval];
      },
    },
  },

  Validate: {
    // Card number validation

    card({number, expYear, expMonth, cvv}) {
      const cleanCardNumber = number?.replace(/\D/g, '');

      if (!cleanCardNumber || cleanCardNumber.length < 13 || cleanCardNumber.length > 19) {
        return {
          valid: false,
          error: t('validation.cardNumber'),
          field: 'card-number'
        };
      }

      let sum = 0;
      let isEven = false;

      for (let i = cleanCardNumber.length - 1; i >= 0; i--) {
        let digit = parseInt(cleanCardNumber.charAt(i));

        if (isEven) {
          digit *= 2;
          if (digit > 9) {
            digit -= 9;
          }
        }

        sum += digit;
        isEven = !isEven;
      }

      if (sum % 10 !== 0) {
        return {
          valid: false,
          error: t('validation.cardNumber'),
          field: 'card-number'
        };
      }

      if (!expMonth) {
        return {
          valid: false,
          error: t('validation.cardExpiration'),
          field: 'card-exp-month'
        };
      }

      if (!expYear) {
        return {
          valid: false,
          error: t('validation.cardExpiration'),
          field: 'card-exp-year'
        };
      }

      const currentDate = new Date();
      const currentYear = currentDate.getFullYear() % 100;
      const currentMonth = currentDate.getMonth() + 1;

       expMonth = parseInt(expMonth);
       expYear = parseInt(expYear);

      if (isNaN(expMonth)) {
        return {
          valid: false,
          error: t('validation.cardExpiration'),
          field: 'card-exp-month'
        };
      }

      if (isNaN(expYear)) {
        return {
          valid: false,
          error: t('validation.cardExpiration'),
          field: 'card-exp-year'
        };
      }

      if (expMonth < 1 || expMonth > 12) {
        return {
          valid: false,
          error: t('validation.cardExpiration'),
          field: 'card-exp-month'
        };
      }

      if (expYear < currentYear || (expYear === currentYear && expMonth < currentMonth)) {
        return {
          valid: false,
          error: t('validation.cardExpired'),
          field: 'card-exp-year'
        };
      }

      if (!cvv || cvv.length < 3 || cvv.length > 4 || !/^\d+$/.test(cvv)) {
        return {
          valid: false,
          error: t('validation.cardCvv'),
          field: 'card-cvv'
        };
      }

      return {
        valid: true,
        error: null,
        field: null
      };
    },

    cpf(cpf) {
      const cleanCpf = (cpf || '').replace(/\D/g, '');
      if (cleanCpf.length !== 11) {
        return getCPFError()
      }

      let sum = 0;
      for (let i = 0; i < 9; i++) {
        sum += parseInt(cleanCpf.charAt(i)) * (10 - i);
      }
      let firstCheck = 11 - (sum % 11);
      if (firstCheck >= 10) firstCheck = 0;
      if (firstCheck !== parseInt(cleanCpf.charAt(9))) {
        return getCPFError()
      }

      sum = 0;
      for (let i = 0; i < 10; i++) {
        sum += parseInt(cleanCpf.charAt(i)) * (11 - i);
      }
      let secondCheck = 11 - (sum % 11);
      if (secondCheck >= 10) secondCheck = 0;
      if (secondCheck !== parseInt(cleanCpf.charAt(10))) {
        return getCPFError()
      }
      return {
        valid: true,
        error: null,
        field: null
      };

      function getCPFError() {
        return {
          valid: false,
          error: t('validation.cpf'),
          field: 'cpf'
        };
      }
    },

    fullName(fullName) {
      if (!fullName || fullName.length < 3) {
        return {
          valid: false,
          error: t('validation.fullName'),
          field: 'name'
        };
      }

      // Remove espaços extras e divide por espaços
      const trimmedName = fullName.trim();
      const nameParts = trimmedName.split(/\s+/);
      
      if (nameParts.length < 2) {
        return {
          valid: false,
          error: t('validation.fullName'),
          field: 'name'
        };
      }
      
      // Verifica se contém apenas letras e espaços
      if (!/^[a-zA-ZÀ-ÿ\s]+$/.test(trimmedName)) {
        return {
          valid: false,
          error: t('validation.fullNameLettersOnly'),
          field: 'name'
        };
      }

      return {
        valid: true,
        error: null,
        field: null
      };
    },

    email(email) {
      if (!email || typeof email !== 'string') {
        return {
          valid: false,
          error: t('validation.emailRequired'),
          field: 'email'
        };
      }

      // Remove espaços em branco
      const trimmedEmail = email.trim();
      
      if (trimmedEmail.length === 0) {
        return {
          valid: false,
          error: t('validation.emailRequired'),
          field: 'email'
        };
      }

      // Regex para validar formato de email
      const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      
      if (!emailRegex.test(trimmedEmail)) {
        return {
          valid: false,
          error: t('validation.emailInvalid'),
          field: 'email'
        };
      }

      // Verifica se não tem caracteres consecutivos inválidos
      if (trimmedEmail.includes('..') || trimmedEmail.startsWith('.') || trimmedEmail.endsWith('.')) {
        return {
          valid: false,
          error: t('validation.emailInvalid'),
          field: 'email'
        };
      }

      // Verifica se o domínio tem pelo menos um ponto
      const domainPart = trimmedEmail.split('@')[1];
      if (!domainPart || !domainPart.includes('.')) {
        return {
          valid: false,
          error: t('validation.emailInvalid'),
          field: 'email'
        };
      }

      return {
        valid: true,
        error: null,
        field: null
      };
    },

    // Accepts the phone DTO ({ code, number }) or a legacy string; rules
    // are country-responsive — the strict digit checks only apply to +55.
    phone(phone) {
      const dto = resolvePhoneDTO(phone);

      if (!dto) {
        return {
          valid: false,
          error: t('validation.phoneRequired'),
          field: 'phone'
        };
      }

      if (dto.code !== '55') {
        // International numbers: national part between 4 and 14 digits
        // (E.164 caps the full number at 15) and not a repeated digit.
        if (dto.number.length < 4 || dto.number.length > 14 || /^(\d)\1+$/.test(dto.number)) {
          return {
            valid: false,
            error: t('validation.phoneInvalid'),
            field: 'phone'
          };
        }

        return {
          valid: true,
          error: null,
          field: null
        };
      }

      const brazilianDigits = dto.number;

      // Verifica se tem 10 ou 11 dígitos brasileiros (com DDD)
      if (brazilianDigits.length < 10 || brazilianDigits.length > 11) {
        return {
          valid: false,
          error: t('validation.phoneDigits'),
          field: 'phone'
        };
      }

      // Se tem 11 dígitos, verifica se o 3º dígito é 9 (celular)
      if (brazilianDigits.length === 11) {
        if (brazilianDigits[2] !== '9') {
          return {
            valid: false,
            error: t('validation.phoneMobileStartsWithNine'),
            field: 'phone'
          };
        }
      }

      // Se tem 10 dígitos, verifica se o 2º dígito é 9 (celular)
      if (brazilianDigits.length === 10) {
        if (brazilianDigits[1] !== '9') {
          return {
            valid: false,
            error: t('validation.phoneMobileStartsWithNine'),
            field: 'phone'
          };
        }
      }

      // Verifica se o DDD é válido (11-99)
      const ddd = brazilianDigits.substring(0, 2);
      const validDDDs = [
        '11', '12', '13', '14', '15', '16', '17', '18', '19', // SP
        '21', '22', '24', // RJ
        '27', '28', // ES
        '31', '32', '33', '34', '35', '37', '38', // MG
        '41', '42', '43', '44', '45', '46', // PR
        '47', '48', '49', // SC
        '51', '53', '54', '55', // RS
        '61', // DF
        '62', '64', // GO
        '63', // TO
        '65', '66', // MT
        '67', // MS
        '68', // AC
        '69', // RO
        '71', '73', '74', '75', '77', // BA
        '79', // SE
        '81', '87', // PE
        '82', // AL
        '83', // PB
        '84', // RN
        '85', '88', // CE
        '86', '89', // PI
        '91', '93', '94', // PA
        '92', '97', // AM
        '95', // RR
        '96', // AP
        '98', '99' // MA
      ];

      if (!validDDDs.includes(ddd)) {
        return {
          valid: false,
          error: t('validation.phoneDdd'),
          field: 'phone'
        };
      }

      // Verifica se não são todos os dígitos iguais
      if (/^(\d)\1+$/.test(brazilianDigits)) {
        return {
          valid: false,
          error: t('validation.phoneInvalid'),
          field: 'phone'
        };
      }

      return {
        valid: true,
        error: null,
        field: null
      };
    }
  }
}

export default H;
